@if (errorMessage) {
  <tidy-error-message
    [text]="errorMessage" />
}

@if (windowService.isDesktopRes) {
  <tidy-desktop-header #websiteHeader>
    <div class="wrappable-container">
      <tidy-text
        [title]="'Direct Booking Sites'" />
      <form [formGroup]="searchForm" novalidate action="#">
        <tidy-search-input
          formControlName="search"
          [placeholder]="'Search'"
          [icon]="'assets/img/search-header.svg'"
          class="header-search" />
      </form>
    </div>
    <div class="non-wrappable-right-aligned-container">
      <automations-preview-button
        [tag]="'direct-booking'" />
    </div>
  </tidy-desktop-header>

  <!-- Skeleton table while loading — rows float in with the entrance cascade;
       the real table below then replaces it in place, instantly (skipEntrance). -->
  @if (!isDataLoaded) {
    <div class="desktop-flex-fill">
      <tidy-table
        [skeletonLoading]="true"
        [columnslabels]="headers" />
    </div>
  }

  @if (isDataLoaded) {
    @if (rows.length > 0) {
      <div class="desktop-flex-fill">
        <tidy-table
          #tidyTable
          [dataSource]="rows"
          [displayedColumns]="headers"
          [columnslabels]="headers"
          [allRowIsClickable]="true"
          [rowsToShow]="25"
          [showColumnLines]="false"
          [blockSorting]="true"
          [skipEntrance]="true"
          (cellClick)="onTableRowClick($event)" />
      </div>
    }

    @if (rows.length === 0) {
      <tidy-alert>
        <tidy-row>
          <tidy-text [body]="'No properties found. Add properties to build direct booking websites.'" />
        </tidy-row>
      </tidy-alert>
    }
  }
}

@if (!windowService.isDesktopRes) {
  @if (!isDataLoaded) {
    <div style="width: 100%">
      <ion-skeleton-text
        animated="true"
        style="height: 75px; border-radius: 6px" />
    </div>
    <div style="width: 100%; padding-top: 1rem;">
      <ion-skeleton-text
        animated="true"
        style="height: 200px; border-radius: 6px" />
    </div>
  }

  @if (isDataLoaded) {
    @for (config of configs; track config.id) {
      <tidy-card>
        <tidy-row>
          <tidy-image
            [src]="'assets/svg/globe-outline.svg'"
            class="header-size" />
          <tidy-text
            [header]="config.property_name"
            [translate]="false" />
        </tidy-row>
        @if (config.property_address) {
          <tidy-row>
            <tidy-text
              [helper]="config.property_address"
              [translate]="false" />
          </tidy-row>
        }

        <tidy-row class="extra-top-padding">
          <tidy-grid>
            <ion-row>
              <ion-col size="6">
                <tidy-row>
                  <tidy-text [helper]="'Custom Domain'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="config.custom_domain || 'Not configured'"
                    [translate]="false" />
                </tidy-row>
              </ion-col>
              <ion-col size="6">
                <tidy-row>
                  <tidy-text [helper]="'Status'" />
                </tidy-row>
                <tidy-row class="vertical-align-center">
                  <span
                    style="display:inline-block;width:8px;height:8px;border-radius:50%;margin-right:6px;"
                    [ngStyle]="{ 'background-color': config.is_published ? 'var(--primary-button, #4295a3)' : '#8E8E93' }"></span>
                  <tidy-text [body]="statusLabel(config)" />
                </tidy-row>
              </ion-col>
            </ion-row>
          </tidy-grid>
        </tidy-row>

        <tidy-row class="extra-top-padding">
          <tidy-image
            [src]="'assets/svg/link-outline.svg'"
            class="body-size" />
          <tidy-text
            [helper]="config.site_url"
            [translate]="false" />
        </tidy-row>

        <tidy-divider />

        <tidy-row class="extra-top-padding">
          <!-- A paused site's URL serves the unavailable page, so it gets the
               detail page (status + a way to turn it on) instead of View. -->
          @if (config.is_published) {
            <tidy-button
              [text]="'View'"
              [action]="getViewAction(config)"
              class="primary" />
            <tidy-button
              [text]="'Update URL'"
              [action]="getDomainAction(config)"
              class="secondary" />
          } @else {
            <tidy-button
              [text]="'Manage Site'"
              [action]="getDomainAction(config)"
              class="primary" />
          }
        </tidy-row>
      </tidy-card>
    }

    @if (configs.length === 0) {
      <tidy-alert>
        <tidy-row>
          <tidy-text [body]="'No properties found. Add properties to build direct booking websites.'" />
        </tidy-row>
      </tidy-alert>
    }
  }
}

@if (showAboutThisPage) {
  <tidy-about-this-page [page]="'direct-booking'" [overlayTop]="overlayTop" (dismissed)="dismissAboutThisPage()" />
}
